// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mlCBA9bDZBO_unnMPuAT {
    width: 1200px;
}

.XDckj1CPML8mLUYnZFXH {
    display: flex;
    justify-content: center;
    padding: calc(var(--unit) * 10) calc(var(--unit) * 5);

    @media (1px <= width <= 768px) {
        padding: calc(var(--unit) * 3) calc(var(--unit) * 4);
    }
}

.n5vxcUnSBYLra1J0X65f {
    display: block;
    height: 52px;

    @media (1px <= width <= 768px) {
        height: 36px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PageHeader/PageHeader.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qDAAqD;;IAErD;QACI,oDAAoD;IACxD;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;;IAEZ;QACI,YAAY;IAChB;AACJ","sourcesContent":[".container {\n    width: 1200px;\n}\n\n.header {\n    display: flex;\n    justify-content: center;\n    padding: calc(var(--unit) * 10) calc(var(--unit) * 5);\n\n    @media (1px <= width <= 768px) {\n        padding: calc(var(--unit) * 3) calc(var(--unit) * 4);\n    }\n}\n\n.logo {\n    display: block;\n    height: 52px;\n\n    @media (1px <= width <= 768px) {\n        height: 36px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `mlCBA9bDZBO_unnMPuAT`,
	"header": `XDckj1CPML8mLUYnZFXH`,
	"logo": `n5vxcUnSBYLra1J0X65f`
};
module.exports = ___CSS_LOADER_EXPORT___;
